import { Box } from '@factorialco/deprecated-design-system'
import type { Moment } from 'moment'

import hasFeature from 'modules/core/lib/hasFeature'

import type Allowance from 'modules/timeoff/store/models/Allowance'

import LegacyStatsCounter from './LegacyStatsCounter'
import NewStatsCounter from './NewStatsCounter'

interface Props {
  employeeId: number
  employeeIsTerminated: boolean
  allowances: Allowance[]
  referenceDate: Moment | undefined
}

const List = ({ employeeId, employeeIsTerminated, allowances, referenceDate }: Props) => (
  <Box gap="s32" paddingTop="s32">
    {allowances.map((allowance) => {
      if (hasFeature('dev_new_timeoff_counters')) {
        return <NewStatsCounter key={allowance.id} employeeId={employeeId} allowance={allowance} />
      }

      return (
        <LegacyStatsCounter
          employeeId={employeeId}
          employeeIsTerminated={employeeIsTerminated}
          key={allowance.id}
          allowance={allowance}
          originalReferenceDate={referenceDate}
        />
      )
    })}
  </Box>
)

export default List
